/** Az elválasztó vonal pozíciójának kulcsa a felhasználói beállítások közt. */
export const resizerControlName = "BANK_REMIT_ITEM_RESIZER";
export const resizerSettingType = "SplitterPosition";
export const defaultLeftWidth = "67%";

/** A bal panel min-width-je, a Resizer viszont ez alá is beírhatja az inline szélességet. */
const minLeftWidth = 33;
const maxLeftWidth = 100;

/**
 * A mentendő/mentett szélesség normalizálása: a min-width alá csúszott értéket felhúzzuk,
 * és egy tizedesre kerekítünk (a húzás "62.83333333333333%"-ot is adhat).
 */
export function clampLeftWidth(width: string): string {
  const parsed = parseFloat(width);
  if (isNaN(parsed)) return defaultLeftWidth;

  return `${Math.min(Math.max(Math.round(parsed * 10) / 10, minLeftWidth), maxLeftWidth)}%`;
}
